<template>
  <v-content>
      <v-app id="inspire">
          <v-snackbar v-model="snackbar" color="success" :timeout="callbackResponse.timeout" top>
              {{callbackResponse.message}}
              <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>

          <v-dialog v-model="signupDialog" persistent max-width="1400px">
              <signup v-if="signupDialog" @formResponse="onResponse" />
          </v-dialog>

          <v-container>
              <v-layout id="login-page-wrapper" row wrap>
                  <v-flex xs12 md8>
                      <v-carousel :show-arrows="false" cycle height="100%">
                          <v-carousel-item v-for="(image, i) in images"
                                           :key="i"
                                           :src="image.src">
                          </v-carousel-item>
                      </v-carousel>
                  </v-flex>

                  <v-flex xs12 md4>
                      <div id="login-page-right">
                          <div id="login-page-right-title">
                              <img src="../../public/Khadya.png" style="padding-right:10px" />
                              <div>
                                  <p class="pa-0 ma-0 header-1" style="color:#8b0000;">
                                      <b>
                                          FOOD MANAGEMENT & TRADING COMPANY LTD.

                                      </b>
                                  </p>
                                  <p class="pa-0 ma-0 header-1" style="color:#8b0000;"><b>Bhadrakali Plaza, Kathmandu</b></p>


                              </div>
                              <img src="../../public/nepal-flag.gif" style="padding-left:10px" />
                          </div>
                          <div calss="mt-1">
                              <h3 style="color:#0a5394;text-align:center;font-size:1.2rem;">
                                  Planning, Budgeting and Reporting System <br />
                                  (PBRS)
                              </h3>
                          </div>
                          <div id="login-section">
                              <v-card-title class=" text-h5" v-text="isSignIn?'Login':' Forget Password'">

                              </v-card-title>

                                <template v-if="isSignIn">
                              <v-card-text>

                                  <v-text-field v-model="name"
                                                :error-messages="nameErrors"
                                                label="UserName"
                                                required
                                                @input="$v.name.$touch()"
                                                @blur="$v.name.$touch()"
                                                outlined
                                                dense
                                                prepend-inner-icon="mdi-account" />
                                  <v-text-field v-model="password"
                                                :error-messages="passwordErrors"
                                                label="Password"
                                                required
                                                outlined
                                                dense
                                                @input="$v.password.$touch()"
                                                @blur="$v.password.$touch()"
                                                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                                @click:append="showPassword = !showPassword"
                                                :type="showPassword ? 'text' : 'password'"
                                                @keyup.enter="submit"/>


                                <!--<vue-recaptcha ref="recaptcha"
                                               @verify="onCaptchaVerified"
                                               @expired="onCaptchaExpired"
                                               sitekey="6LdN8ikjAAAAAFyJgmsphCJI8SUfmdSyN09xUFcE" :loadRecaptchaScript="true">


                                </vue-recaptcha>-->

                                  <div class="d-flex flex-row-reverse">
                                      <a @click="isSignIn=false">Forgot Password?</a>
                                  </div>

                                  <div class="d-flex justify-end mt-2">
                                      <v-btn small color="primary" @click="submit" :loading="loading">
                                          <template v-slot:loader>
                                              <v-progress-circular indeterminate size="17" color="white"></v-progress-circular>
                                          </template>
                                          Login
                                      </v-btn>
                                  </div>
                              </v-card-text>

                                </template>
                            <template v-else>
                              <v-card-text>
                                <PasswordReset @back="isSignIn=true" />
                              </v-card-text>
                            </template>

                              <v-spacer></v-spacer>


                          </div>

                          <div class="d-flex flex-column justify-center align-center">

                              <div style="text-align:center" class="d-flex flex-row justify-center align-center">
                                  <div class="pr-1 font-weight-bold">Developed by</div>
                                  <img src="../../public/trans-logo.png" height="34" width="34" />
                                  <div class="pl-1 font-weight-bold">FOOD MANAGEMENT & TRADING COMPANY LTD, Nepal</div>
                              </div>
                          </div>
                      </div>
                  </v-flex>

              </v-layout>

          </v-container>





      </v-app>
  </v-content>
</template>



<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
    import signup from "./Signup";
//    import VueRecaptcha from 'vue-recaptcha';
import PasswordReset from "@/public_pages/PasswordReset";


export default {
  name: "Signin",
        components: {PasswordReset, signup},
  props: {
    source: String
  },
  watch: {
    alert(newValue) {
      // Close after 5 seconds
      if (newValue) {
        setTimeout(this.hideAlert, 5000);
      }
    }
  },
  validations: {
    name: { required},
    password: { required }
  },

  data() {
    return {
      isSignIn: true,
      callbackResponse: {
        timeout: 6000
      },
      showPassword: false,
      snackbar: false,
      signupDialog: false,
      alert: false,
      timeout: 2000,
      tab: null,
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      loading: false,
      right: false,
      error: "",
      tabs: 3,
      name: "",
      password: "",
      errors: "",
      images: [
            { src: require('../../public/img7.jpg') },
            { src: require('../../public/img8.jpg') },
            { src: require('../../public/img9.jpg') },
            { src: require('../../public/img10.jpg') },
            { src: require('../../public/img11.jpg') },
            { src: require('../../public/img12.jpg') },
        ],
      colors: [
            'primary',
            'secondary',
            'yellow darken-2',
            'red',
            'orange',
        ]
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "authenticated"
    }),
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required");
      return errors;
    }
  },
  destroyed() {},
  created() {
    localStorage.clear();
    this.initialize();
  },
        methods: {
            //onCaptchaExpired: function () {
            //    this.$refs.recaptcha.reset();
            //},
            //onCaptchaVerified(recaptchaToken) {
            //    if (recaptchaToken) {
            //        this.isVarifyed = true
            //    }
            //},
    onResponse(data) {
      if(data.message){
        this.signupDialog = false;
        this.callbackResponse = data;
        this.snackbar = true
        }
        else {
          this.signupDialog = false;
        }
    },
    signup() {
      this.signupDialog = true;
    },
    hideAlert() {
      // console.log("hide");
      this.alert = false;
    },
    //redirected to auth->signIn
    ...mapActions({
      signIn: "signIn"
    }),
    initialize() {
      this.apiResponse("error");
            },

            async submit() {
                this.loading = true
               //// for recaptcha

               // if (this.isVarifyed) {
               //     this.$v.$touch();
               //     let formdata = JSON.stringify({
               //         UserName: this.name,
               //         password: this.password
               //     });
               //     //mapaction called

               //     let response = await this.signIn(formdata);
               //     if (response && response.data != 200) {
               //         this.alert = true;
               //         this.error = "User Name or Password MisMatch";
               //     }
               // } else {
               //     this.snackbar = true

               //     this.callbackResponse.message = "Please verify you are a human.";
               // }
    //##start
            /*    this.$refs.recaptcha.reset()*/
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    let formdata = JSON.stringify({
                        UserName: this.name,
                        password: this.password
                    });
                    //mapaction called
                    let response = await this.signIn(formdata);
                    this.loading= false
                    if (response.data !== 200) {
                        this.snackbar = true
                        this.alert = true;
                        this.error = response.data;
                        this.callbackResponse.message = this.error;
                    }
                }
      
              //  #end
    }
  }
};
</script>
<style lang="scss" scoped>
.v-item-group {
  background: #1565c0;
}
</style>

<style scoped>
  #login-section {
      align-self: flex-start;
      width:95%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 100px;
  }
  #login-page-right-title > img {
      width: 100px;
      height:100px;
  }
  #login-page-right-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: center;
  }
  #login-page-right {
      height: 100%;
      padding: 20px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
  }

  #login-page-wrapper {

    max-width: 100vw !important;
    min-height: 100vh !important;
    max-height: 100vh !important;
  }

  .center-div {
    max-width: 900px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .grid-button-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 14px;
  }

  .no-text-decoration {
    text-decoration: none;
  }

  .text-teal {
    color: teal;
  }
</style>
